import { ISettingsType } from '../types';
import { onValue, set } from "firebase/database";
import { firebase } from '../config/firebase.client';
import { EDIT_SETTINGS, FETCH_SETTINGS, CLEAR_SETTINGS_ERROR, FETCH_SETTINGS_SUCCESS, FETCH_SETTINGS_FAILED } from "../store/types";


export const fetchSettings = () => (dispatch: any) => {
  const { settingsRef } = firebase;

  dispatch({
    type: FETCH_SETTINGS,
    payload: null,
  });

  onValue(settingsRef, (snapshot) => {
    if (snapshot.val()) {
      dispatch({
        type: FETCH_SETTINGS_SUCCESS,
        payload: snapshot.val(),
      });
    } else {
      dispatch({
        type: FETCH_SETTINGS_FAILED,
        payload: "Unable to fetch database and settings.",
      });
    }
  });
};

export const editSettings = (settings: Partial<ISettingsType>) => (dispatch: any) => {
  const { settingsRef } = firebase;

  dispatch({
    type: EDIT_SETTINGS,
    payload: settings
  });
  set(settingsRef, settings);
};

export const clearSettingsViewError = () => (dispatch: any) => {
  dispatch({
    type: CLEAR_SETTINGS_ERROR,
    payload: null
  });
};